import localize, { fetchLangTags, localizeFormat, setMomentLang, getTypeName, getLocalizationTag } from "./localize";

export { localize, localizeFormat, fetchLangTags, setMomentLang, getTypeName, getLocalizationTag };
